import { makeVar } from '@apollo/client';
import { AuthTokens } from '@/lib/types/auth';

export const authVar = makeVar<AuthTokens | null>(null);
